import React, { useState } from "react"
import { navigate } from "@reach/router"
import styled from "@emotion/styled"

import { useAuth } from "../../hooks/auth-context"
import KYC from "../../services/kyc"

import CustomButtonV2 from "../ui/custom-button-v2"
import { css } from "@emotion/react"


const ContractTitle = styled.h2`
  min-width: 616px;
  font-family: 'Work Sans';
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  color: #454F5B;
  text-align: center;

  @media (max-width: 812px) {
    min-width: 100%;
  }
`

const ContractAndAnnex = styled.p`
  color: #363f41;
  font-weight: bold;
  font-size: 13.33px;
  line-height: 140%;
  text-align: center;
  margin-bottom: 0;
  & > a {
    color: #5C6AC4;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Roboto';
    line-height: 18px;
  }
`

const buttonStyle = css`
  margin-top: 1.5rem;
  padding: 0px;
  width: 18.95rem;
  background-color: #2ba770;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
`

const loadingButtonStyle = buttonStyle


type Terms = {
  contract: string
  detail: ItemTerm[]
}


type Props = {
  terms: Terms
}

const TermsDetails = ({ terms }: Props) => {
  const { state } = useAuth()
  const user = state.user as User

  const [isLoading, setIsLoading] = useState(false)


  const onSubmit = async () => {
    setIsLoading(true)

    const result = await KYC.updateTerms(user)
    state.setUser(result.user)
    setIsLoading(false)
    navigate(`/${result.user.kycNextStep}`)
  }

  return (
    <>
      <ContractTitle>Aceptación Términos y condiciones</ContractTitle>

      <ContractAndAnnex>
        <a href={terms.contract} target="_blank" rel="noopener noreferrer">
          Ver términos, condiciones y sus anexos
        </a>
      </ContractAndAnnex>

      <CustomButtonV2
        style={buttonStyle}
        onClick={onSubmit}
        loading={isLoading}
        loadingStyle={loadingButtonStyle}
      >
        Acepto los términos y condiciones
      </CustomButtonV2>
    </>
  )
}

export default TermsDetails
